import { MetaFilter } from "@/shared/filters-by-meta";
import { PersonSelectExtendedTable } from "./person-select-extended-table";
import { PersonSelectExtendedTags } from "./person-select-extended-tags";
import { FilterableEntity } from "gql/graphql";
import { PersonSelectExtendedProps } from "./person-select-extended";

type PersonSelectExtendedFieldProps = Omit<PersonSelectExtendedProps, "close">;

export function PersonSelectExtendedField({
  value,
  onChange,
  mode,
}: PersonSelectExtendedFieldProps) {
  return (
    <div>
      <MetaFilter
        filterableEntity={FilterableEntity.CommonPerson}
        primary="name"
      >
        <MetaFilter.Controls />

        {(value ?? []).length > 0 && (
          <div className="mb-4">
            <PersonSelectExtendedTags value={value} onChange={onChange} />
          </div>
        )}

        <PersonSelectExtendedTable
          value={value}
          onChange={onChange}
          mode={mode}
        />
      </MetaFilter>
    </div>
  );
}
